import { IsoLocale } from '@izettle/constants';

const supportedLocales = Object.values(IsoLocale);
const getLocale = function (userLocales) {
  let allowedLocales = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : supportedLocales;
  // We need to hard-code the locale to ensure consistency in stories and their snapshots.
  // TODO: Create a storybook addon that sets this for us, and allows changing locale
  if (process.env.IS_STORYBOOK) {
    return IsoLocale.enGB;
  }
  const usersValidLocale = userLocales.find(locale => allowedLocales.includes(locale));
  if (usersValidLocale != null) {
    return usersValidLocale;
  }
  const languagesWithoutCountries = userLocales.map(locale => locale.includes("-") ? locale.slice(0, locale.indexOf("-")) : locale);
  const firstBestLocale = allowedLocales.find(locale => locale.startsWith(languagesWithoutCountries));
  return firstBestLocale ?? null;
};

export { getLocale };
//# sourceMappingURL=get-locale.js.map
